import React from "react";
import EAButton from "./EAButton";
import { handleApiException, useHttp } from "../services/HttpService";
import { useConfirmation } from "./ConfirmationDialog/ConfirmationDialogProvider";

/**
 * Erstellt eine Schaltfläche, welche einen Download startet.
 * @param id die Id der Schaltfläche
 * @param label der darzustellende Text
 * @param url die Url der herunterzuladenden Datei
 * @param data Daten für Post
 * @param confirmOptions Falls vor dem Download ein Bestätigungsdialog mit dem Optionen angezeigt werden soll
 * @param config Anstatt der URL kann auch eine ganze config übergeben werden. Die URL wird in diesem Fall ignoriert.
 * @param loading Falls der Export zusätzlich zum Download-Loading, ein weiteres Loading bekommen soll.
 * @param disabled
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function EADownloadButton({ id, label, url, data, confirmOptions, config = null, loading = false, disabled = false, ...rest }) {
    const method = data ? "POST" : "GET";
    const [fileDownloader, fetchFile] = useHttp(config ? config : { url, method: method, responseType: "blob", data: data }, { manual: true });
    const confirm = useConfirmation();

    function handleFileDownload() {
        fetchFile()
            .then((response) => {
                const filename = response.headers["content-disposition"].split('filename="')[1].replaceAll('"', "");
                const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch(
                (e) => (e.response.data?.text()?.then((response) => handleApiException(e, "Error downloading file", response)))
            );
    }

    return (
        <EAButton
            id={id}
            label={label}
            onClick={() =>
                confirmOptions
                    ? confirm({
                          ...confirmOptions,
                          onClose: () => {},
                          onSubmit: handleFileDownload,
                      })
                    : handleFileDownload()
            }
            loading={loading || fileDownloader.loading}
            disabled={loading || fileDownloader.loading || disabled}
            {...rest}
        />
    );
}

export default EADownloadButton;
